module.exports = __webpack_public_path__ + "img/qr_code.5e97765c.jpg";